import api from '../services/api.js';

// URL SSO per ogni servizio (pattern: /auth/sso?token=xxx)
const SERVICE_SSO_URLS = {
  review: 'https://review.doid.it/auth/sso',
  page: 'https://page.doid.it/auth/sso',
  menu: 'https://menu.doid.it/auth/sso',
};

/**
 * Genera token SSO e redirige al servizio esterno.
 * Usato per:
 * - Service-first redirect dopo registrazione da ads (autoSetup.requestedService)
 * - Redirect dopo cambio password per utenti migrati (migratedFrom)
 *
 * @param {string} serviceCode - Codice servizio (review, page, menu)
 * @returns {boolean} true se il redirect e' stato avviato, false altrimenti
 */
export async function redirectToService(serviceCode) {
  if (!serviceCode || !SERVICE_SSO_URLS[serviceCode]) {
    return false;
  }

  try {
    const response = await api.getSsoRedirectToken(serviceCode);

    if (response.success && response.data?.token) {
      window.location.href = `${SERVICE_SSO_URLS[serviceCode]}?token=${response.data.token}`;
      return true;
    }
  } catch (err) {
    console.error('[SSO] Service redirect failed:', err);
  }

  return false;
}
